module.exports = __webpack_public_path__ + "static/media/light_icn_map_pin_bus_ls.9b3ae595.svg";